module.exports = __webpack_public_path__ + "static/img/h6-3.2b5e159.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner1/h6-3.png
// module id = g1a4
// module chunks = 1